export const SCHOOL_TYPE = 'school-type';
export const PROFESSION = 'profession';
